module.exports = __webpack_public_path__ + "img/58.8.TSS.b71704e5.png";